export default "__VITE_ASSET__f8948fe9__"